import { isUndefined } from "lodash";
import { areAllElementsNumbers } from "../../../lib/areAllElementsNumbers";
export const validateLogin = (idbg, pin, serverURL) => {
  const messages = {};
  if (typeof idbg === "undefined" || idbg === "") {
    messages.idbg = "Account name is required";
  }
  // Bilo je `typeof pin === undefined` — poređenje NISKE sa VREDNOŠĆU, dakle
  // uvek netačno. Grana nikad nije radila, a provere ispod nje su onda pucale
  // na `Object.values(undefined)`: umesto poruke „Pin is required" dobijala se
  // izuzetak. Zato i `else` — bez njega ispravka samo pomera mesto pucanja.
  if (typeof pin === "undefined" || pin === "") {
    messages.pin = "Pin is required";
  } else {
    // `pin` je OBJEKAT `{0..5}`, ne niz. Obe provere ispod rade nad nizom, pa
    // im se vrednosti moraju izvaditi — inače `pin.length` je `undefined`, uslov
    // `=== 6` nikad nije tačan, a `areAllElementsNumbers` se ne izvrti nijednom
    // i vraća `true`. Poruka „Pin must be a number" se do 28.08.2026. nije
    // pojavila nijednom.
    const cifre = Object.values(pin);
    // Provere se ISKLJUČUJU. Bez `else` bi nepopunjen PIN okinuo obe, a druga
    // bi prepisala prvu — pa bi korisniku sa praznim poljem pisalo „Pin must be
    // a number", iako cifre nisu pogrešne nego jedna fali.
    //
    // Prazno polje se broji kao NEDOSTAJUĆE, ne kao „nije broj": kutija koja
    // nije popunjena nije pogrešno popunjena.
    const nedostaje = cifre.some((val) => isUndefined(val) || val === "");
    if (cifre.length !== 6 || nedostaje) {
      messages.pin = "Pin must have a 6 digits";
    } else if (!areAllElementsNumbers(cifre)) {
      messages.pin = "Pin must be a number";
    }
  }
  if (typeof serverURL === "undefined" || serverURL === "") {
    messages.serverURL = "Server is required";
  }

  if (Object.keys(messages).length > 0) {
    return { valid: false, errors: messages };
  }

  return { valid: true, errors: null };
};
